import React, { useEffect, useReducer } from "react"
import { Box, Flex, Text, theme } from "@singita/components"
import { gql } from "@apollo/client"
import { ACTIONS, donationReducer, initialValue, STEPS } from "./reducer"
import Donation from "./ui/Donation"
import ContactInfo from "./ui/ContactInfo"
import AddressInfo from "./ui/AddressInfo"
import Confirmation from "./ui/Confirmation"
import { useMutation } from "@apollo/client"
import { client } from "../../apollo/availability-client"
import { Media } from "gatsby-singita-theme/src/Media"

export const STEP_COMPONENTS = {
  [STEPS.AMOUNT]: Donation,
  [STEPS.DETAILS]: ContactInfo,
  [STEPS.ADDRESS]: AddressInfo,
  [STEPS.CONFIRM]: Confirmation,
}

const DonationContainer = ({ fundId, campaignId, emailId }) => {
  const [state, dispatch] = useReducer(donationReducer, initialValue)
  const { currentStep } = state
  const [createDonation, { loading }] = useMutation(CREATE_DONATION, {
    client: client,
  })
  const Component = STEP_COMPONENTS[currentStep]
  const steps = Object.values(STEPS)
  const idxOfStep = steps.findIndex(p => p === currentStep)

  useEffect(() => {
    if (state.form.token) {
    }
  }, [state.form.token])

  const setValue = (step, payload) => {
    dispatch({
      type: ACTIONS.UPDATE_FORM,
      payload,
    })
  }

  return (
    <Box my={[2]} bg={theme.colors.baseWhite} py={[2]} px={[4]}>
      <Flex justifyContent="space-between" mb={[5]}>
        {Object.values(STEPS).map((step, idx) => {
          const isCurrent = currentStep === step
          return (
            <>
              <Text
                key={`step-${idx}`}
                size="small"
                fontWeight="bold"
                color={isCurrent ? "brandBrown" : "baseGray"}
                sx={{
                  opacity: isCurrent ? "full" : "medium",
                  transition: `all ${theme.speed.default} ease`,
                  display: "flex",
                }}
              >
                {idx + 1}.{" "}
                {isCurrent ? (
                  step
                ) : (
                  <Media greaterThanOrEqual="lg">{step}</Media>
                )}
              </Text>
            </>
          )
        })}
      </Flex>
      <Component
        error={state.error}
        values={state.form}
        emailId={emailId}
        campaignId={campaignId}
        fundId={fundId}
        onError={error =>
          dispatch({
            type: ACTIONS.ERROR,
            payload: error,
          })
        }
        onChange={e =>
          dispatch({
            type: ACTIONS.UPDATE_FORM,
            payload: {
              [e.target.name]: e.target.value,
            },
          })
        }
        onNext={() => {
          dispatch({
            type: ACTIONS.ERROR,
            payload: "",
          })
          dispatch({
            type: ACTIONS.STEP,
            payload: steps[idxOfStep + 1],
          })
        }}
        onPrev={() => {
          dispatch({
            type: ACTIONS.STEP,
            payload: steps[idxOfStep - 1],
          })
        }}
        onSetValues={payload => setValue(currentStep, payload)}
      />
    </Box>
  )
}

export default DonationContainer

export const CREATE_DONATION = gql`
  mutation createDonation($input: InputDonationDetails!) {
    createDonation(input: $input) {
      message
    }
  }
`
